import React from 'react'

import {
    LANDING_BONUS_FIRST_ITEM_HEADER,
    LANDING_BONUS_SECOND_ITEM_HEADER,
    LANDING_BONUS_THIRD_ITEM_HEADER,
    LANDING_BONUS_FIRST_ITEM_MESSAGE,
    LANDING_BONUS_SECOND_ITEM_MESSAGE,
    LANDING_BONUS_THIRD_ITEM_MESSAGE,
} from './constants'

import styles from './LandingBonus.scss'

const LandingBonus = () => {
    return (
        <div className={styles.base}>
            <div className={styles.items}>
                <div className={styles.itemsContainer}>
                    <div className={styles.item}>
                        <div className={styles.imageContainer}>
                            <div className={styles.reserve} />
                        </div>
                        <div className={styles.itemHeader}>{LANDING_BONUS_THIRD_ITEM_HEADER}</div>
                        <div className={styles.itemMessage}>{LANDING_BONUS_THIRD_ITEM_MESSAGE}</div>
                    </div>
                    <div className={styles.item}>
                        <div className={styles.imageContainer}>
                            <div className={styles.gold} />
                        </div>
                        <div className={styles.itemHeader}>{LANDING_BONUS_SECOND_ITEM_HEADER}</div>
                        <div className={styles.itemMessage}>{LANDING_BONUS_SECOND_ITEM_MESSAGE}</div>
                    </div>
                    <div className={styles.item}>
                        <div className={styles.imageContainer}>
                            <div className={styles.vehicle} />
                        </div>
                        <div className={styles.itemHeader}>{LANDING_BONUS_FIRST_ITEM_HEADER}</div>
                        <div className={styles.itemMessage}>{LANDING_BONUS_FIRST_ITEM_MESSAGE}</div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default LandingBonus



// WEBPACK FOOTER //
// ./containers/Landing/components/LandingBonus/LandingBonus.jsx